import Vue from 'vue';
import Router from 'vue-router';
import LandingPage from '@/components/pages/LandingPage';
import AboutPage from '@/components/pages/About';
import ContactPage from '@/components/pages/Contact';
import ClientPage from '@/components/pages/Client';
import CareerPage from '@/components/pages/Career';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Start',
      component: LandingPage,
    },
    {
      path: '/about',
      name: 'About',
      component: AboutPage,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: ContactPage,
    },
    {
      path: '/client',
      name: 'Client',
      component: ClientPage,
    },
    {
      path: '/career',
      name: 'Career',
      component: CareerPage,
    },
  ],
});
